import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/footer/picto_linkedin_footer.svg")